import Vue from 'vue'
import vuex from 'vuex'
import prompt from './modules/prompt'
import user from './modules/user'
Vue.use(vuex);

export default new vuex.Store({
  modules:{
    prompt,
    user
  },
});
